import { Alert, AlertTitle, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../hooks/useAuth';
import { PATH_DASHBOARD } from '../routes/paths';
import { getEinProblemCopy, shouldRemindAboutEin } from '../utils/einStatus';

export default function EinStatusAlert(others) {
  const { user } = useAuth();
  const { t } = useTranslation();

  if (!shouldRemindAboutEin(user)) return null;

  const copy = getEinProblemCopy(user.ein_status);
  if (!copy) return null;

  return (
    <Alert severity="warning" {...others}>
      <AlertTitle>{copy.title}</AlertTitle>
      {copy.body}
      {copy.selfServiceable && user.is_admin ? (
        <>
          {' '}
          <Link
            component={RouterLink}
            to={PATH_DASHBOARD.settings.business('settings', 'tax-settings')}
          >
            {t('ein-status.update-your-ein')}
          </Link>
        </>
      ) : null}
    </Alert>
  );
}
